const INITIAL_STATE = {
  purchaseOptions: [],
  cart: [],
  purchaseItemFilter: '',
  loaded: false
};

export const activitiesPurchaseReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'INITIALIZE_ACTIVITIES_PURCHASE_PAGE': {
      return {
        ...state,
        purchaseOptions: action.payload,
        loaded: true
      };
    }
    case 'ACTIVITIES_PURCHASE_PAGE_UPDATE_CART':
      return {
        ...state,
        cart: action.payload
      };
    case 'ACTIVITIES_PURCHASE_PAGE_UPDATE_FILTER_STRING':
      return {
        ...state,
        purchaseItemFilter: action.payload
      };
    case 'CLEAR_ACTIVITIES_PURCHASE_PAGE':
      return INITIAL_STATE;
    default:
      return state;
  }
};
